export enum InviteIdentificationType {
  VoucherCode = 'voucher-code',
  InviteId = 'invite-id',
}
